import { BrandLogo } from '@elva/ui';
import type { ReactNode } from 'react';
import { ElvaPageLoader } from '@/components/ElvaPageLoader';

export interface ElvaSectionStateProps {
  isLoading?: boolean;
  isError?: boolean;
  children: ReactNode;
  className?: string;
}

export function ElvaSectionState({
  isLoading = false,
  isError = false,
  children,
  className,
}: ElvaSectionStateProps) {
  if (isLoading) {
    return className ? <ElvaPageLoader className={className} /> : <ElvaPageLoader />;
  }

  if (isError) {
    return (
      <div
        className={
          className ??
          'flex min-h-0 flex-1 flex-col items-center justify-center gap-4 py-16'
        }
      >
        <BrandLogo src="/logo.svg" alt="Elva" className="h-10 w-10" />
        <p className="text-[13px] text-[var(--ink-3)]">Something went wrong</p>
      </div>
    );
  }

  return <>{children}</>;
}
